import clsx from 'clsx';
import type {
  GroupBase,
  GroupHeadingProps as ReactSelectGroupHeadingProps,
} from 'react-select';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';
import { Flex } from '@dynatrace/strato-components/layouts';
import { Text } from '@dynatrace/strato-components/typography';

import { selectGroupHeadingCSS } from '../styles/Select.sty.js';

type GroupHeadingProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactSelectGroupHeadingProps<
  OptionValue,
  isMulti,
  Group & { labelProps?: StylingProps & DataTestId }
>;

export function GroupHeading<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
>(props: GroupHeadingProps<OptionValue, isMulti, Group>) {
  const {
    id,
    children,
    data: { labelProps },
  } = props;
  const {
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = labelProps ?? {};

  return (
    <Flex
      paddingX={12}
      paddingTop={12}
      paddingBottom={4}
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      <Text
        as="span"
        id={id}
        textStyle="small-emphasized"
        className={clsx(selectGroupHeadingCSS)}
      >
        {children}
      </Text>
    </Flex>
  );
}
